import { state } from "./state";
import { mutations } from "./mutations";
import { actions } from "./actions";

export const invoices = {
  state,
  mutations,
  actions
};
